/* eslint-disable no-undef */

import AdditionalRequirement from
	'./transportation_requests/additional_requirements_inputs';

export default class TransportationRequestForm {
	static init() {
		$(() => {
			const form = document.querySelector('#transportation_request_form form');
			if (form) new TransportationRequestForm(form);
		});
	}

	constructor(form) {
		this.form = form;
		this.init_additional_requirements_inputs();
	}

	// Transportation request additional requirements
	// initialization for creation form
	init_additional_requirements_inputs() {
		this.form
			.querySelectorAll('.additional_requirements > label')
			.forEach(requirement => {
				let input = requirement.querySelector('input');
				if (!input) return;

				this.form[input.name.match(/\[(.+)\]$/)[1]] =
					new AdditionalRequirement(requirement);
			});
	}
}
